import { loadJS } from 'core/api/loadJS.js';

const componentName = "business_component/print/print/main/index";
const url = "../../../../business_component/print/print/main/index.js";

let output = (...args) => {
    loadJS(url, () => {
        let res = window[componentName].default || window[componentName];
        res.output(...args);
    });
};
export { output };